<script lang="ts">
  import Calendar from '$icons/CalendarIcon.svelte';
  import { createEventDispatcher } from 'svelte';
  import GlobalTextInput from './GlobalTextInput.svelte';
  import SimpleCaption from './SimpleCaption.svelte';

  export let value;
  export let label = '';
  export let caption = '';
  export let placeholder = 'Enter here';
  export let danger: boolean = false;
  export let dangerMessage: string = '';
  export let pattern: string = null;
  export let inputRegex: RegExp = null;
  export let inputVerifing: boolean = false;
  export const inputFocused = false;

  const dispatch = createEventDispatcher();

  $: {
    value, label;
    dispatch('change', { value, label });
  }

  function handleSubmit() {
    dispatch('change', value);
  }
</script>

<div class="flex flex-col items-start gap-2 w-full">
  <label class="text-[#47675B] font-medium text-sm" for="">
    {#if label}{label}{:else}&nbsp;{/if}
  </label>
  <div class="flex flex-row gap-0 items-center min-h-[54px] w-full">
    <GlobalTextInput
      unround="r"
      {pattern}
      {danger}
      {placeholder}
      {inputRegex}
      {inputVerifing}
      hideCaption
      bind:value
      on:blur
      on:focus
      on:submit={handleSubmit}
    />

    <div
      role="button"
      tabindex="0"
      class="min-w-[50px] border border-l-0 rounded-l-none border-[#D0DDD7]
      rounded-14 p-4 text-[#66857D] flex justify-center items-center
      cursor-pointer"
      class:input-danger={danger || dangerMessage}
      on:keydown
      on:click={() => {
        dispatch('icon-click');
      }}
    >
      <slot>
        <Calendar />
      </slot>
    </div>
  </div>
  <SimpleCaption {danger} {dangerMessage} {caption} variant={'styled'} />
</div>

<style type="postcss">
  .input-danger {
    @apply border-[#D75870];
  }
  .input-danger:focus {
    box-shadow:
      1px 1px 2px rgba(0, 0, 0, 0.07),
      0px 0px 0px 4px #ffecec;
  }

  /* .text {
		background: linear-gradient(180deg, #fbfefd 0%, #f8fdfb 100%);
	} */
</style>
